import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    APIModel,
    AuthConfig,
    AuthenticationType,
    B2CPolicies,
    Environment,
    I18nModel,
    isSalesforceAuth,
} from '../../../environments/environment.model';
import { RUNTIME_CONFIG } from '../../app.config';

@Injectable({
    providedIn: 'root',
})
export class RuntimeConfigService {
    private readonly config = inject(RUNTIME_CONFIG);

    public getConfig(): Environment {
        return this.config;
    }

    public getAuthenticationType(): AuthenticationType | string {
        return this.config.authenticationType || AuthenticationType.Entra;
    }

    public isSalesforceAuth(): boolean {
        return isSalesforceAuth(this.config);
    }

    public getAuthConfig(): AuthConfig {
        return this.config.auth || ({} as AuthConfig);
    }

    public getMsalConfig(): B2CPolicies {
        return this.config.msal || ({} as B2CPolicies);
    }

    public getApiConfig(): APIModel | undefined {
        return this.config.api;
    }

    public getApiBasePath(): string {
        return this.config.api?.basePath ? `${this.config.api?.basePath}/api/v1` : '';
    }

    public getAuthClientId(): string {
        return this.config.auth?.clientId || '';
    }

    public getAuthIssuer(): string {
        return this.config.auth?.issuer || '';
    }

    public getMsalClientId(): string {
        return this.config.msal?.applicationClientId || '';
    }

    public getMsalB2cTenantName(): string {
        return this.config.msal?.b2cTenantName || '';
    }

    public getEnvironment(): string {
        return environment.name;
    }

    public getApplicationId(): string {
        return this.config.api?.applicationId || '';
    }

    public getI18nConfig(): I18nModel {
        return this.config.i18n || ({} as I18nModel);
    }
}
